export const VOICE_ENGINE_OPTIONS = [
  { value: "elevenlabs-v2", label: "Basic 11-2" },
  { value: "elevenlabs-v3", label: "Basic 11-3" },
  { value: "eleven_text_to_sound_v2", label: "SFX" },
];

export const DEFAULT_VOICE_ENGINE = "elevenlabs-v3";

export const SOUND_EFFECT_VOICE_ENGINE = "eleven_text_to_sound_v2";

export const LEGACY_AUDIO_ENGINE_LABEL = "Legacy audio engine";

const SUPPORTED_VOICE_ENGINE_VALUES = new Set(
  VOICE_ENGINE_OPTIONS.map((option) => option.value)
);

export const isSupportedVoiceEngine = (voiceEngine) =>
  SUPPORTED_VOICE_ENGINE_VALUES.has(voiceEngine);

export const isLegacyVoiceEngine = (voiceEngine) =>
  Boolean(voiceEngine) && !isSupportedVoiceEngine(voiceEngine);

export const getSupportedVoiceEngine = (voiceEngine) =>
  isSupportedVoiceEngine(voiceEngine) ? voiceEngine : DEFAULT_VOICE_ENGINE;

export const getVoiceEngineLabel = (voiceEngine) => {
  if (isLegacyVoiceEngine(voiceEngine)) {
    return LEGACY_AUDIO_ENGINE_LABEL;
  }

  return (
    VOICE_ENGINE_OPTIONS.find((option) => option.value === voiceEngine)?.label ||
    voiceEngine ||
    DEFAULT_VOICE_ENGINE
  );
};
